import {
  GridColDef,
  DataGridPro,
  GridSortModel,
  GridSlotsComponent,
  GridColumnVisibilityModel,
  GridInitialState
} from '@mui/x-data-grid-pro';
import { SxProps } from '@mui/material';
import { v4 } from 'uuid';
import { DataGridProProps } from '@mui/x-data-grid-pro';
import { DEFAULT_TABLE_STYLES } from '../../../utils/styleHelpers';
/* eslint-disable @typescript-eslint/no-explicit-any */
export interface Column {
  title: string;
}

export interface BasicDataGridProps {
  rows: any[];
  columns: GridColDef[];
  className?: string;
  dataCy?: string;
  dataTestId?: string;
  sxStyle?: SxProps;
  sortModel?: GridSortModel;
  disableColumnMenu?: boolean;
  disableColumnResize?: boolean;
  showColumnVerticalBorder?: boolean;
  showCellVerticalBorder?: boolean;
  slots?: Partial<GridSlotsComponent>;
  showToolbar?: boolean;
  pinnedColumns?: { left: string[]; right: string[] };
  slotProps?: DataGridProProps['slotProps'];
  primaryKey?: string;
  hideFooterRowCount?: boolean;
  columnVisibilityModel?: GridColumnVisibilityModel;
  onColumnVisibilityModelChange?: (model: GridColumnVisibilityModel) => void;
  initialState?: GridInitialState;
  localLoading?: boolean;
}

export const BasicDataGrid = ({
  rows,
  columns,
  className,
  dataCy = '',
  dataTestId = '',
  sxStyle,
  sortModel,
  disableColumnMenu = false,
  disableColumnResize = false,
  showColumnVerticalBorder = false,
  showCellVerticalBorder = false,
  slots,
  showToolbar = false,
  pinnedColumns,
  slotProps,
  primaryKey,
  hideFooterRowCount = true,
  columnVisibilityModel = undefined,
  onColumnVisibilityModelChange = undefined,
  initialState = undefined,
  localLoading = undefined
}: BasicDataGridProps) => {
  return (
    <div
      data-testid={dataTestId}
      className={className}>
      <DataGridPro
        hideFooter={hideFooterRowCount}
        rows={rows || []}
        disableRowSelectionOnClick
        disableColumnFilter
        sortModel={sortModel || undefined}
        columns={columns}
        hideFooterPagination
        hideFooterRowCount={hideFooterRowCount}
        columnHeaderHeight={DEFAULT_TABLE_STYLES.headerHeight}
        rowHeight={DEFAULT_TABLE_STYLES.rowHeight}
        sx={sxStyle || DEFAULT_TABLE_STYLES.sx}
        data-cy={dataCy}
        disableColumnMenu={disableColumnMenu}
        disableColumnResize={disableColumnResize}
        showColumnVerticalBorder={showColumnVerticalBorder}
        showCellVerticalBorder={showCellVerticalBorder}
        getRowId={(row) => (primaryKey ? row[primaryKey] : v4())}
        slots={slots}
        slotProps={slotProps}
        showToolbar={showToolbar}
        pinnedColumns={pinnedColumns}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={onColumnVisibilityModelChange}
        initialState={initialState}
        loading={localLoading}
      />
    </div>
  );
};
